import React from 'react'
import { useHistory } from 'react-router-dom'

import {
  RenewalPlanPeriodResponse,
  getIchraBenefitDesignState,
  getIchraDesignBenefitWizard,
  getRenewalPlanPeriod,
} from 'core'

import { useQueryRequest } from '../../../../common/hooks'
import { ROUTE_PATHS } from '../../../../common/routePaths'
import DesignBenefitWizard from '../common/DesignBenefitWizard'
import { NavItemsMapping, ReadonlyStepsWhenBenefitIsFinished } from './DesignStepsMapping'

const IchraDesignBenefit: React.FC = () => {
  const history = useHistory()
  const [, , sendGetRenewalPlanPeriod] = useQueryRequest<RenewalPlanPeriodResponse>(null)

  return (
    <DesignBenefitWizard
      getBenefitDesignWizard={(planPeriodId) => getIchraDesignBenefitWizard(planPeriodId)}
      getBenefitDesignWizardState={(planPeriodId) => getIchraBenefitDesignState(planPeriodId)}
      navItemsMapping={NavItemsMapping}
      readonlyStepsWhenBenefitIsFinished={ReadonlyStepsWhenBenefitIsFinished}
      onFinish={async (planPeriodId) => {
        const result = await sendGetRenewalPlanPeriod(() => getRenewalPlanPeriod())
        history.push(
          result?.id == planPeriodId ? `${ROUTE_PATHS.RENEWAL_TASKS}` : `${ROUTE_PATHS.ADMIN_DASHBOARD_PATH}`,
        )
      }}
    />
  )
}

export default IchraDesignBenefit
